export function setDesignTab(state, payload) {
  const newTabValue = payload;
  const previousTabValue = state.designChapter.currentView.viewType;
  const previousTab = getPreviousTab(state.designChapter);
  const newTab = getNewTab(state.designChapter, newTabValue);
  return {
    ...state,
    designChapter: {
      ...state.designChapter,
      [previousTabValue]: previousTab,
      currentView: newTab,
    },
  };
}

function getPreviousTab(designChapter) {
  return designChapter.currentView;
}
function getNewTab(designChapter, newTabValue) {
  return designChapter[newTabValue];
}
